import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { TableLoader } from "../../../Common/ShimmerLoader";
import { innergetVehicleReport } from "../../../Apis/satReportsApi";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import { GetZone } from "../../../Apis/organizationApi";
import ExcelJS from "exceljs";
import { Field, Form, Formik } from "formik";
import useFilterStore from "./store/useFilterStore";
import { formattedDate, getCurrentDateTime1, getCurrentISTDate } from "../../../Common/helper/helpar";

const ViewSatVehiclereport = () => {
  const {
    zoneWiseFilters
  } = useFilterStore();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [zoneName, setZoneName] = useState("");
  const location = useLocation();
  const {data,fromDate} = location.state
  const [zonesData, setZonesData] = useState([]);
  const [satCondemnedVehicles, setsatCondemnedVehicles] = useState(data);


  const vehicleReportColumns = [
    {
      name: "S.No",
      selector: (row) => row["slno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
       width: '70px'
    },
    {
      name: "Zone",
      selector: (row) => row["zoneName"],
      cell: (row) => <span>{row["zoneName"] || "N/A"}</span>,
      sortable: true,
       width: '120px'
    },
    {
      name: "Circle",
      selector: (row) => row["circleName"],
      cell: (row) => <span>{row["circleName"] || "N/A"}</span>,
      sortable: true,
       width: '120px'
    },
    {
      name: "Ward",
      selector: (row) => row["wardName"],
      cell: (row) => <span> {row["wardName"] || "N/A"}</span>,
      sortable: true,
       width: '120px'
    },
    {
      name: <>Vehicle Type</>,
      selector: (row) => row["vehicleType"],
      cell: (row) => <span>{row["vehicleType"] || "N/A"}</span>,
      sortable: true,
       width: '120px'
    },
    {
      name: <>Owner Type</>,
      selector: (row) => row["ownerType"],
      cell: (row) => <span>{row["ownerType"] || "N/A"}</span>,
      sortable: true,
       width: '120px'
    },
    {
      name: <>Vehicle Number</>,
      selector: (row) => row["vehicleNumber"],
      cell: (row) => <span>{row["vehicleNumber"] || "N/A"}</span>,
      sortable: true,
       width: '120px'
    },
    {
      name: <>Driver Name</>,
      selector: (row) => row["driverName"],
      cell: (row) => <span>{row["driverName"] || "N/A"}</span>,
      sortable: true,
       width: '120px'
    },
    {
      name: <>Driver Number</>,
      selector: (row) => row["driverNumber"],
      cell: (row) => <span>{row["driverNumber"] || "N/A"}</span>,
      sortable: true,
       width: '120px'
    },
    {
      name: "SFA Name",
      selector: (row) => row["sfaName"],
      cell: (row) => (
        <span>{row["sfaName"] || "N/A"}</span>
      ),
      sortable: true,
       width: '120px'
    },
    {
      name: <>SFA Number</>,
      selector: (row) => row["sfaMobileNumber"],
      cell: (row) => (
        <span>{row["sfaMobileNumber"] || "N/A"}</span>
      ),
      sortable: true,
      //  width: '135px'
    },

    // {
    //   name: "Vehicle Image",
    //   cell: (row) => {
    //     if (row["vehicleImageUrl"]) {
    //       return (
    //         <img
    //           src={row["vehicleImageUrl"]}
    //           alt="Vehicle"
    //           style={{ maxWidth: "100px", maxHeight: "100px" }}
    //         />
    //       );
    //     } else {
    //       return <span style={{ color: "blue" }}>No image</span>;
    //     }
    //   },
    //   sortable: true,
    // },
  ];


  useEffect(() => {
    const fetchZoneName = async () => {
      try {
        const zoneData = await GetZone();
        const zoneIdFromLocalStorage = localStorage.getItem("zoneId");
        const zoneNamesDictionary = {};

        // Populate the zoneNamesDictionary with zoneId as keys and zoneName as values
        zoneData.forEach((zone) => {
          zoneNamesDictionary[zone.zoneId] = zone.zoneName;
        });

        // Find the zone name corresponding to the zoneId from localStorage
        const zoneName = zoneNamesDictionary[zoneIdFromLocalStorage];

        // Use zoneName as needed
        setZoneName(zoneName);
      } catch (error) {
        console.error("Error fetching zone name:", error);
      }
    };

    fetchZoneName();
  }, []);
  const modifiedData = data && data.map((item) => ({
    ...item,
    zone: item.zoneName,
    circle: item.circleName,
    ward: item.wardName,
  }));

  useEffect(() => {
    fetchData(); // Fetch data when component mounts with default selected dates
  }, []);
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await innergetVehicleReport(
      );
      setZonesData(response);
      // Handle the response data as needed
    } catch (error) {
      console.error("Error fetching Vehicle wise report:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDates = `${currentDate.getDate()}-${currentDate.getMonth() + 1
      }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `SATs Zone Wise Condemned Vehicles Report ${fromDate ? formattedDate(fromDate) : getCurrentISTDate()} (at ${getCurrentDateTime1()})`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    // Define styles
    const boldFont = { bold: true };

    // Add row for download date and time
    const downloadDateTime = `Reported on: ${formattedDates} ${formattedTime}`;
    const dateTimeRow = worksheet.addRow(["", "", downloadDateTime, "", ""]);
    worksheet.mergeCells(1, 3, 1, 5);
    dateTimeRow.getCell(3).font = boldFont; // Set style for the cell
    dateTimeRow.getCell(3).alignment = { horizontal: "center" }; // Center align the cell content
    dateTimeRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 5) {
        // Apply styles to download date and time cells
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    // Add row for cumulative heading report
    const cumulativeHeadingRow = worksheet.addRow(["", "", cumulativeHeadingReport, "", ""]);
    worksheet.mergeCells(2, 3, 2, 6);
    cumulativeHeadingRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 7) {
        // Apply styles to cumulative heading report cells
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone",
      "Circle",
      "Ward",
      "Vehicle Type",
      "Owner Type",
      "Vehicle Number",
      "Driver Name",
      "Driver Number",
      "SFA Name",
      "SFA Number"
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 14) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" } // Red background color
        };
      }
    });

    // Add data rows
    satCondemnedVehicles.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.zoneName ?? "N/A",
        item.circleName ?? "N/A",
        item.wardName ?? "N/A",
        item.vehicleType ?? "N/A",
        item.ownerType ?? "N/A",
        item.vehicleNumber ?? "N/A",
        item.driverName ?? "N/A",
        item.driverNumber ?? "N/A",
        item.sfaName ?? "N/A",
        item.sfaMobileNumber?? "N/A"
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 12) {
          // Align the columns from 1 to 4 to the left
          cell.alignment = { horizontal: "left" };
        } else {
          // Align the rest of the columns to the center
          cell.alignment = { horizontal: "center" };
        }
      });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 26 },
      { width: 26 },
      // { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ZoneWiseCondemnedVehiclesReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };


  // Filterss
  const filterFields = { searchCircle: "", searchWard: "", searchSFAIncharge: "" };

  const searchReportedAtVehicleHandler = (values) => {
    const termCircle = values.searchCircle ? values.searchCircle.toLowerCase() : "";
    const termWard = values.searchWard ? values.searchWard.toLowerCase() : "";
    const termSFAIncharge = values.searchSFAIncharge ? values.searchSFAIncharge.toLowerCase() : "";

    const filteredData = data.filter(item => {
      const circleName = item?.circleName ? item.circleName.toLowerCase() : "";
      const vehicle = item?.wardName ? item.wardName.toLowerCase() : "";
      const SFAIncharge = item?.sfaName ? item.sfaName.toLowerCase() : "";
      const SFAInchargeNumber = item?.sfaMobileNumber ? item.sfaMobileNumber.toString() : "";

      const matchesCircle = !termCircle || circleName.includes(termCircle);
      const matchesWard = !termWard || vehicle.includes(termWard);
      const matchesSFAName = !termSFAIncharge || SFAIncharge.includes(termSFAIncharge);

      const isNumber = /^[0-9]+$/.test(termSFAIncharge);
      const matchesSFA = !termSFAIncharge ||
        SFAIncharge.includes(termSFAIncharge) ||
        (isNumber && SFAInchargeNumber.includes(termSFAIncharge));

      return matchesCircle && matchesWard && matchesSFA;
    });

    setsatCondemnedVehicles(filteredData);
  };
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              {/* <div class="row" style={{ textAlign: "justify" }}>
            </div> */}

              <div className="card">
                <div className="card-body">
                  <div className="row align-items-end mt-3">
                    <div className="col-md-9">
                      <div className="row">


                        <Formik initialValues={filterFields}>
                          {({ handleChange, values }) => (
                            <Form >
                              <div className="row">
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <Field
                                      name="searchCircle"
                                      placeholder="Search Circle"
                                      type="text"
                                      className="form-control bg-white"
                                      onInput={(e) => {
                                        handleChange(e);
                                        searchReportedAtVehicleHandler({ ...values, searchCircle: e.target.value });
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <Field
                                      name="searchVehicleNumber"
                                      placeholder="Search Ward"
                                      type="text"
                                      className="form-control bg-white"
                                      onInput={(e) => {
                                        handleChange(e);
                                        searchReportedAtVehicleHandler({ ...values, searchWard: e.target.value });
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <Field
                                      name="searchSFAIncharge"
                                      placeholder="Search SFA Incharge Name or Number"
                                      type="text"
                                      className="form-control bg-white"
                                      onInput={(e) => {
                                        handleChange(e);
                                        const searchValue = e.target.value.trim();

                                        // Check if input is a number or name
                                        const isNumber = /^[0-9]+$/.test(searchValue);

                                        // Send appropriate search query
                                        searchReportedAtVehicleHandler({
                                          ...values,
                                          searchSFAIncharge: searchValue, // Keep the same key for both name & number
                                          searchBy: isNumber ? "number" : "name" // Add a key to indicate search type
                                        });
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="d-flex justify-content-end mt-3 mb-3">
                        <button className="btn btn-secondary  me-2" style={{}}
                          onClick={() => navigate(-1, { state: data })}
                        >
                          Back
                        </button>
                        <button className="btn btn-excel"
                          onClick={downloadAsExcel}
                        >
                          <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                        </button>

                      </div>
                    </div>




                  </div>

                  <div className="top-header">

                    <span>
                      {" "}
                      Zone Wise Condemned Vehicles Report on {fromDate ? formattedDate(fromDate) : getCurrentISTDate()} (at {getCurrentDateTime1()})
                    </span>
                  </div>

                  <CustomDataTable
                    //data={zonesData}
                    data={satCondemnedVehicles}
                    //  data={modifiedData}
                    columns={vehicleReportColumns}
                  // headers={headers}
                  // link={true}
                  // search={true}
                  // fromDate={fromDate}
                  // toDate={toDate}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewSatVehiclereport;
